import React, {useContext, useEffect, useState} from 'react';

import {PAContext} from "../../../Services/PAContext";
import {
    Avatar,
    Button,
    Card,
    CardContent,
    CardMedia,
    Collapse,
    Dialog, DialogActions,
    DialogContent,
    DialogTitle,
    Paper, Tooltip
} from "@mui/material";
import './receipt.css';
import Badge from "@mui/material/Badge";
import Typography from "@mui/material/Typography";
import ReceiptCard from "./ReceiptCard";
import {PieChart} from "@mui/x-charts/PieChart";
import usePA_GlobalStore from "../../../Services/ZustandGlobalStore";
import {capitalizeFirstLetter, formatName, stringAvatar, stringToColor} from "../../Helpers/TextStyling";
import InfoReceipts from "../../Dialogs/InfoReceipts";
import {useNavigate} from "react-router-dom";
import Box from "@mui/material/Box";

import no_receipts_placeholder from '../../../graphics/no_receipts_placeholder_fun_travel.png';
import IconButton from "@mui/material/IconButton";
import {
    PieChart as PieChartIcon,
    Info,
    Plus,
    Sparkles,
    } from "lucide-react";
import {getAllContactsFromDatabase} from "../../Restricted/Contacts/BrowserDatabaseFunctions";
import {Stack} from "@mui/system";



function ReceiptList(props){

    const navigate = useNavigate();

    const { PA_GlobalObject, set_PA_GlobalObject } = usePA_GlobalStore();

    const { dataArray, registerReceiptBinary, sendSocketMessage } = useContext(PAContext);
    const { Account, SampleAttendees, authenticated  } = dataArray;

    const [dbContacts, setDbContacts] = useState([]);
    useEffect(() => {
        if (!authenticated) {
            setDbContacts([]);
            return;
        }

        let cancelled = false;

        getAllContactsFromDatabase()
            .then(contacts => {
                if (cancelled) return;
                setDbContacts(Array.isArray(contacts) ? contacts : []);
            })
            .catch(err => {
                console.error('Failed to load Contacts from browser DB:', err);
                if (!cancelled) {
                    setDbContacts([]);
                }
            });

        return () => {
            cancelled = true;
        };
    }, [authenticated]);

    const [ attendeesReferenceArray, setAttendeesReferenceArray ] = useState( authenticated
        ? dbContacts
        : SampleAttendees);
    useEffect(() => {

        console.log("authenticated, dbContacts, SampleAttendees triggered ...");

        setAttendeesReferenceArray(
            authenticated
                ? dbContacts
                : SampleAttendees
        );
    }, [authenticated, dbContacts, SampleAttendees]);

    const [selectedAttendee, setSelectedAttendee] = useState(Account.id);
    const [eventReceipts, setEventReceipts] = useState([]);
    const [filteredReceipts, setFilteredReceipts] = useState([]);


    useEffect(() => {
        console.log("PA_GlobalObject.Planning.receipts : ",PA_GlobalObject.Planning.receipts);
        if (PA_GlobalObject.Planning.receipts) {
            filterReceipts();
        }
    }, [PA_GlobalObject.Planning.receipts, selectedAttendee, Account.id, setFilteredReceipts]);

    const [anchorReceiptsListMenu, setAnchorReceiptsListMenu] = useState(null);
    const handleReceiptsListMenuOpenMenu = (event) => {
        setAnchorReceiptsListMenu(event.currentTarget);
    };
    const handleReceiptsListMenuClick = (event) => {
        const target = event.currentTarget;
        const dataId = target.getAttribute('data-id');

        handleReceiptsListMenuClose();

        if (dataId === "new-entry"){
            navigate('/Planner/Receipts/AddNew');
        }
    };
    const handleReceiptsListMenuClose = () => {
        setAnchorReceiptsListMenu(null);
    };
    
    const handleChipClick = (_attendee_id) => {
        console.log("Show receipts for : "+_attendee_id);
        setSelectedAttendee(_attendee_id);
    }

    function handlePromptChangeClose() {
        props.setShowEventItemConfig(false);
    }

    const attendeesWithReceiptCounts = PA_GlobalObject.Planning.attendees.map((attendee) => {
        const receiptCount = PA_GlobalObject.Planning.receipts.reduce((count, item) =>
            count + ((item.attendee_id === attendee.id && (!item.private || item.attendee_id === Account.id)) ? 1 : 0), 0
        );
        return { ...attendee, receiptCount };
    });
    const attendeesWithReceipts = attendeesWithReceiptCounts.filter(attendee => attendee.receiptCount > 0);
    const attendeesWithoutReceipts = attendeesWithReceiptCounts.filter(attendee => attendee.receiptCount === 0);
    attendeesWithReceipts.sort((a, b) => b.receiptCount - a.receiptCount);
    attendeesWithoutReceipts.sort((a, b) => a.nickname.localeCompare(b.nickname));
    const sortedAttendees = [...attendeesWithReceipts, ...attendeesWithoutReceipts];


    const filterReceipts = () => {
        console.log("filterReceipts for : "+selectedAttendee);

        const filteredItems = PA_GlobalObject.Planning.receipts.filter(receipt =>
            receipt.attendee_id === selectedAttendee && (!receipt.private || receipt.attendee_id === Account.id)
        );

        console.log("setting the filterReceipts to : ",filteredItems);

        setEventReceipts(filteredItems);
        setFilteredReceipts(filteredItems); // Initialize with all filtered receipts
    };



    const sectionColorMap = {
        Meals: '#e8f2ed',
        Activities: '#cbe0f7',
        Lodging: '#fef4ec',
        General: '#EDE7F6',
        Flights: '#fcf9dd',
        Supplies:'#FEE5D4',
        Shopping:'#B2D4F0',
        Incidentals:'#FAF3CC',
        Transportation:'#D6F5E4'
    };



    const getAnalyticsData = () => {
        let grandTotal = 0;
        let businessTotal = 0;
        const categoryMap = {};

        filteredReceipts.forEach(receipt => {
            const section = receipt.section || 'General';
            const amount = parseFloat(receipt.amount) || 0; // Check both properties safely
            const business_amount = parseFloat(receipt.business_expense_amount) || 0; // Check both properties safely

            grandTotal += amount;

            // Track business expenditures (adapts to boolean flags or string types)
            if (receipt.is_business_expense) {
                businessTotal += business_amount;
            }

            if (categoryMap[section]) {
                categoryMap[section] += amount;
            } else {
                categoryMap[section] = amount;
            }
        });

        const pieChartData = Object.entries(categoryMap)
            .sort(([a], [b]) => a.localeCompare(b))
            .map(([section, amount], index) => ({
                id: index,
                value: amount,
                label: `${section} ($${amount.toFixed(0)})`, // Baked cleanly into the legend label string
                color: sectionColorMap[section] || '#cbd5e1',
            }));

        return {
            grandTotal,
            businessTotal,
            personalTotal: grandTotal - businessTotal,
            pieChartData
        };
    };

    const { grandTotal, businessTotal, personalTotal, pieChartData } = getAnalyticsData();


    function handleEditReceipt(receipt_id, updatedData) {
        console.log("handleEditReceipt for ID:", receipt_id);

        const targetReceipt = eventReceipts.find(r => r.id === receipt_id);
        if (!targetReceipt) return;

        // --- CASE 1: REPLACING WITH A NEW FILE ---
        // Detect if the update includes a new binary file from the replacement dialog
        if (updatedData.new_file_binary) {
            const fileBinary = updatedData.new_file_binary;

            // Create a temporary object to register the binary locally.
            // We update the metadata (name, type, size) to match the new file.
            const tempReceiptWithFile = {
                ...targetReceipt,
                full_data: fileBinary,
                file_name: updatedData.file_name,
                file_type: updatedData.file_type,
                file_size: updatedData.file_size
            };

            // Store the binary in your local Ref/Cache
            registerReceiptBinary(receipt_id, tempReceiptWithFile);

            // Remove the raw binary from updatedData so we don't send it over JSON/Socket
            const { new_file_binary, ...cleanUpdatedData } = updatedData;

            const _sendString = {
                action: "E_requestEventReceiptUploadUrlForGCS",
                event_id: PA_GlobalObject.Planning.id,
                receipt_id: targetReceipt.id,
                file_name: updatedData.file_name,
                file_type: updatedData.file_type,
                pending_updates: cleanUpdatedData // Carry over any other edits (like notes/amount)
            };

            sendSocketMessage(_sendString);
            return; // Exit: The socket listener will handle the actual upload once the URL arrives
        }

        // --- CASE 2: BASE64 DATA (NEWLY ADDED BUT NOT YET UPLOADED) ---
        if (targetReceipt.full_data && typeof targetReceipt.full_data === 'string' && targetReceipt.full_data.startsWith("data:")) {
            registerReceiptBinary(targetReceipt.id, targetReceipt);

            const _sendString = {
                action: "E_requestEventReceiptUploadUrlForGCS",
                event_id: PA_GlobalObject.Planning.id,
                receipt_id: targetReceipt.id,
                file_name: targetReceipt.file_name,
                file_type: targetReceipt.file_type,
                pending_updates: updatedData
            };
            sendSocketMessage(_sendString);
            return;
        }

        // --- CASE 3: STANDARD METADATA UPDATES ---
        const updatedReceipt = { ...targetReceipt, ...updatedData };

        // Update the Global Store locally for instant UI feedback
        set_PA_GlobalObject((prev) => {
            const newReceipts = prev.Planning.receipts.map(r =>
                r.id === receipt_id ? updatedReceipt : r
            );
            return {
                ...prev,
                Planning: { ...prev.Planning, receipts: newReceipts }
            };
        });

        // Send standard updates to server
        if (PA_GlobalObject.Planning.status!== 10) {
            const _sendString = {
                action: "E_updateEventReceipt",
                event_id: PA_GlobalObject.Planning.id,
                receipt: updatedReceipt
            };
            sendSocketMessage(_sendString);
        }
    }

    const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false);
    const [receiptIdToDestroy, setReceiptIdToDestroy] = useState(null);
    const handleDelete = (receiptId) => {
        setReceiptIdToDestroy(receiptId);
        setDeleteConfirmOpen(true);
    };
    const executeDelete = () => {
        if (!receiptIdToDestroy) return;

        const receiptId = receiptIdToDestroy;

        // Remove from local filter state
        setFilteredReceipts((prevReceipts) => prevReceipts.filter(receipt => receipt.id !== receiptId));

        // Remove from Global Store
        set_PA_GlobalObject((prev) => {
            return {
                ...prev,
                Planning: {
                    ...prev.Planning,
                    receipts: prev.Planning.receipts.filter(receipt => receipt.id !== receiptId)
                }
            };
        });

        // Sync with server
        if (PA_GlobalObject.Planning.status!== 10) {
            const _sendString = {
                action: "E_deleteEventReceipt",
                event_id: PA_GlobalObject.Planning.id,
                receipt_id: receiptId
            };
            sendSocketMessage(_sendString);
        }

        // Cleanup
        setReceiptIdToDestroy(null);
    };
    const handleDeleteOLD = (receiptId) => {
        setFilteredReceipts((prevReceipts) => prevReceipts.filter(receipt => receipt.id !== receiptId));

        // Remove from Global Store (PA_GlobalObject)
        set_PA_GlobalObject((prev) => {
            return {
                ...prev,
                Planning: {
                    ...prev.Planning,
                    receipts: prev.Planning.receipts.filter(receipt => receipt.id !== receiptId)
                }
            };
        });

        if (PA_GlobalObject.Planning.status!== 10) {
            const _sendString = {
                action: "E_deleteEventReceipt",
                event_id: PA_GlobalObject.Planning.id,
                receipt_id: receiptId
            };
            sendSocketMessage(_sendString);

        }

    };

    const [showChart, setShowChart] = useState(false);
    const [isReceiptsInfoDialogOpen, setReceiptsInfoDialogOpen] = useState(false);


    return (

        <div className="receipts-list-container">

            {/* Fun & Professional Header */}
            <Paper
                elevation={0}
                sx={{
                    p: 1.2,
                    background: 'rgba(255, 255, 255, 0.8)',
                    backdropFilter: 'blur(12px)',
                    border: '1px solid rgba(255, 255, 255, 0.6)',
                    boxShadow: '0 4px 24px -6px rgba(0,0,0,0.06)'
                }}
            >
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    {/* Title Area */}
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Box sx={{
                            background: 'linear-gradient(135deg, #6366f1 0%, #a855f7 100%)',
                            p: 0.9,
                            borderRadius: '10px',
                            display: 'flex',
                            boxShadow: '0 4px 10px rgba(99, 102, 241, 0.3)'
                        }}>
                            <i className="icon-receipt" style={{color: 'white', fontSize: '18px'}}/>
                        </Box>
                        <Box sx={{minWidth: 0}}>
                        <Typography variant="h6" sx={{ fontWeight: 800, color: '#1e293b', fontSize: '1rem', letterSpacing: -0.4, whiteSpace: 'nowrap' }}>
                                Receipts
                            </Typography>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.3 }}>
                                <Sparkles size={10} color="#8b5cf6" />
                                <Typography variant="caption" sx={{ color: '#64748b', fontWeight: 700, fontSize: '0.65rem', letterSpacing: 0.1, whiteSpace: 'nowrap' }}>
                                    Adventure Tracker
                                </Typography>
                            </Box>
                        </Box>
                    </Box>

                    {/* Controls Area */}
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                        {/* Stats Toggle Button */}
                        <Tooltip title="Spending Analytics">
                            <IconButton
                                onClick={() => setShowChart(!showChart)}
                                sx={{
                                    bgcolor: showChart ? '#f5f3ff' : 'transparent',
                                    color: showChart ? '#7c3aed' : '#64748b',
                                    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                    '&:hover': { bgcolor: '#f5f3ff', color: '#7c3aed' }
                                }}
                            >
                                <PieChartIcon size={20} />
                            </IconButton>
                        </Tooltip>

                        {/* Info Icon */}
                        <Tooltip title="Info">
                            <IconButton
                                onClick={() => setReceiptsInfoDialogOpen(!isReceiptsInfoDialogOpen)}
                                sx={{ color: '#64748b' }}
                            >
                                <Info size={20} />
                            </IconButton>
                        </Tooltip>

                        {/* Direct Add Button */}
                        <Tooltip title="Add New Receipt">
                            <IconButton
                                data-id="new-entry"
                                onClick={handleReceiptsListMenuClick}
                                sx={{
                                    ml: 0.5,
                                    bgcolor: '#1e293b',
                                    color: 'white',
                                    borderRadius: '12px',
                                    width: '38px',
                                    height: '38px',
                                    boxShadow: '0 4px 12px rgba(30, 41, 59, 0.25)',
                                    transition: 'all 0.2s ease',
                                    '&:hover': {
                                        bgcolor: '#334155',
                                        transform: 'translateY(-1px)',
                                        boxShadow: '0 6px 16px rgba(30, 41, 59, 0.3)',
                                    },
                                    '&:active': { transform: 'translateY(0px)' }
                                }}
                            >
                                <Plus size={20} strokeWidth={2.5} />
                            </IconButton>
                        </Tooltip>
                    </Box>
                </Box>
            </Paper>

            {/* Attendee List */}
            <div className="documents-list-attendee-list-container" style={{
                display: 'flex',
                overflowX: 'auto',
                msOverflowStyle: 'none',
                alignItems: 'flex-start'
            }}>
                {sortedAttendees.map((attendee) => {
                    // 1. Logic to find the real avatar data
                    const attendeeAvatar = attendeesReferenceArray.find((_att) => _att.id === attendee.id);
                    const isSelected = selectedAttendee === attendee.id;

                    const fullName = attendee.nickname?.trim()
                        ? `${formatName(attendee.nickname)}`
                        : `${formatName(attendee.fname)} ${formatName(attendee.lname)}`;

                    return (
                        <Box
                            key={attendee.id}
                            onClick={() => handleChipClick(attendee.id)}
                            sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                cursor: 'pointer',
                                position: 'relative',
                                minWidth: '60px',
                                transition: 'transform 0.2s ease',
                                '&:hover': {transform: 'translateY(-2px)'}
                            }}
                        >
                            {/* 2. The Notification Badge for Document Counts */}
                            <Badge
                                badgeContent={attendee.documentCount > 0 ? attendee.documentCount : null}
                                sx={{
                                    '& .MuiBadge-badge': {
                                        backgroundColor: '#151269',
                                        color: 'white',
                                        fontSize: '10px',
                                        fontWeight: 900,
                                        border: '2px solid #fff',
                                        top: 5,
                                        right: 5
                                    },
                                }}
                            >
                                {/* 3. The Avatar with your Lodging Logic */}
                                <Box sx={{
                                    p: '3px',
                                    borderRadius: '50%',
                                    border: isSelected ? '2px solid #151269' : '2px solid transparent',
                                    transition: 'all 0.3s ease'
                                }}>
                                    {
                                        !attendeeAvatar?.avatar || !attendeeAvatar?.avatar.preview ? (
                                            <Avatar
                                                {...stringAvatar(fullName)}
                                                sx={{
                                                    width: 30,
                                                    height: 30,
                                                    fontSize: '16px',
                                                    fontWeight: 600,
                                                    boxShadow: isSelected ? '0 4px 10px rgba(21, 18, 105, 0.2)' : 'none',
                                                    border: `1px solid ${stringToColor(fullName)}`
                                                }}
                                            />
                                        ) : (
                                            <Avatar
                                                src={attendeeAvatar.avatar.preview}
                                                sx={{
                                                    width: 30,
                                                    height: 30,
                                                    boxShadow: isSelected ? '0 4px 10px rgba(21, 18, 105, 0.2)' : 'none',
                                                    border: `1px solid ${stringToColor(fullName)}`
                                                }}
                                            />
                                        )
                                    }
                                </Box>
                            </Badge>

                            {/* 4. Name Label */}
                            <Typography sx={{
                                fontSize: '11px',
                                fontWeight: isSelected ? 800 : 500,
                                mt: 1,
                                color: isSelected ? '#151269' : '#666',
                                textAlign: 'center',
                                maxWidth: '70px',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap'
                            }}>
                                {capitalizeFirstLetter(attendee.nickname || attendee.fname)}
                            </Typography>
                        </Box>
                    );
                })}
            </div>


            {/* Receipts List */}
            <div className="receipts-list-items-container">

                {/* Collapsible Analytics Section */}
                <Collapse in={showChart}>
                    <Box sx={{ mt: 2, pt: 2, borderTop: '1px solid #e2e8f0' }}>

                        {pieChartData.length > 0 ? (
                            <Stack spacing={2.5}>
                                {/* --- TOP ROW: FINANCIAL SUMMARIES GRID --- */}
                                <Box sx={{
                                    display: 'grid',
                                    gridTemplateColumns: 'repeat(3, 1fr)',
                                    gap: 1,
                                    bgcolor: '#f8fafc',
                                    p: 1.5,
                                    borderRadius: '12px',
                                    border: '1px solid #f1f5f9'
                                }}>
                                    <Box sx={{ textAlign: 'center' }}>
                                        <Typography sx={{ fontSize: '9px', fontWeight: 800, color: '#64748b', letterSpacing: '0.5px' }}>
                                            GRAND TOTAL
                                        </Typography>
                                        <Typography sx={{ fontSize: '14px', fontWeight: 900, color: '#1e293b', mt: 0.2 }}>
                                            ${grandTotal.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                        </Typography>
                                    </Box>

                                    <Box sx={{ textAlign: 'center', borderLeft: '1px solid #e2e8f0', borderRight: '1px solid #e2e8f0' }}>
                                        <Typography sx={{ fontSize: '9px', fontWeight: 800, color: '#0284c7', letterSpacing: '0.5px' }}>
                                            BUSINESS
                                        </Typography>
                                        <Typography sx={{ fontSize: '14px', fontWeight: 900, color: '#0284c7', mt: 0.2 }}>
                                            ${businessTotal.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                        </Typography>
                                    </Box>

                                    <Box sx={{ textAlign: 'center' }}>
                                        <Typography sx={{ fontSize: '9px', fontWeight: 800, color: '#64748b', letterSpacing: '0.5px' }}>
                                            PERSONAL
                                        </Typography>
                                        <Typography sx={{ fontSize: '14px', fontWeight: 700, color: '#475569', mt: 0.2 }}>
                                            ${personalTotal.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                        </Typography>
                                    </Box>
                                </Box>

                                {/* --- MIDDLE ROW: ULTRA COMPACT GRAPHIC --- */}
                                <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%', my: -1 }}>
                                    <PieChart
                                        series={[
                                            {
                                                data: pieChartData,
                                                innerRadius: 18, // Enlarged slightly for an elite donut accent feel
                                                outerRadius: 48,
                                                paddingAngle: 3,
                                                cornerRadius: 4,
                                                startAngle: 0,
                                                endAngle: 360,
                                                cx: 60, // Pulled leftwards to give legend breathing room
                                                cy: 50,
                                            },
                                        ]}
                                        slotProps={{
                                            legend: {
                                                direction: "column",
                                                position: { vertical: "middle", horizontal: "right" },
                                                labelstyle: {
                                                    fontSize: 10, // Crisp typography designed for small formats
                                                    fontWeight: 700,
                                                    fill: '#334155',
                                                },
                                                itemgap: 6,
                                            },
                                        }}
                                        width={320}
                                        height={110}
                                    />
                                </Box>

                                {/* --- BOTTOM ROW: METRICS TRACK BAR (BUSINESS DISTRIBUTION) --- */}
                                {grandTotal > 0 && (
                                    <Box sx={{ px: 0.5 }}>
                                        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
                                            <Typography sx={{ fontSize: '9px', fontWeight: 800, color: '#64748b' }}>
                                                BUSINESS EXPENSE DISTRIBUTION
                                            </Typography>
                                            <Typography sx={{ fontSize: '9px', fontWeight: 900, color: '#0284c7' }}>
                                                {((businessTotal / grandTotal) * 100).toFixed(0)}%
                                            </Typography>
                                        </Box>
                                        {/* Custom Micro Linear Progress track */}
                                        <Box sx={{ width: '100%', height: '6px', bgcolor: '#e2e8f0', borderRadius: '3px', overflow: 'hidden' }}>
                                            <Box sx={{
                                                width: `${(businessTotal / grandTotal) * 100}%`,
                                                height: '100%',
                                                bgcolor: '#0284c7',
                                                borderRadius: '3px',
                                                transition: 'width 0.5s ease-out'
                                            }} />
                                        </Box>
                                    </Box>
                                )}
                            </Stack>
                        ) : (
                            <Box sx={{ py: 2, textAlign: 'center' }}>
                                <Typography sx={{ fontSize: '11px', color: '#94a3b8', fontWeight: 600 }}>
                                    No receipt entries to calculate data.
                                </Typography>
                            </Box>
                        )}

                    </Box>
                </Collapse>


                {
                    filteredReceipts && filteredReceipts.length > 0 ? (
                        Object.entries(
                            filteredReceipts.reduce((acc, receipt) => {
                                acc[receipt.section] = acc[receipt.section] || []; // Initialize category if not present
                                acc[receipt.section].push(receipt); // Group receipts by section
                                return acc;
                            }, {})
                        )
                            .sort(([a], [b]) => a.localeCompare(b))
                            .map(([section, receipts]) => (
                            <ReceiptCard
                                key={section}
                                section={section}
                                receipts={receipts}
                                onEdit={handleEditReceipt}
                                onDelete={handleDelete} />
                        ))
                    ) : (
                        <Card
                            sx={{
                                borderRadius: '5px', // More rounded corners
                                boxShadow: '0 8px 24px rgba(0,0,0,0.15)', // Deeper shadow for a modern feel
                                maxWidth: '600px', // Constrain width for better readability
                                mx: 'auto', // Center the card
                                overflow: 'hidden', // Ensure image corners are rounded
                                backgroundColor: '#ffffff', // Clean white background
                            }}
                        >
                            <CardMedia
                                sx={{ height: 200, objectFit: 'cover' }} // Cover ensures image fills space
                                image= {no_receipts_placeholder}
                                title="Ready to Track Your Adventures"
                            />

                            <CardContent sx={{ padding: { xs: '16px', sm: '24px' } }}> {/* Responsive padding */}
                                {/* Title */}
                                <Typography variant="h5" component="h2" sx={{
                                    fontSize: { xs: '20px', sm: '24px' }, // Responsive font size
                                    fontWeight: 700,
                                    color: '#673ab7', // A vibrant purple
                                    marginBottom: '1rem',
                                    textAlign: 'center',
                                }}>
                                    ✨ Your Adventure Budget Awaits! ✨
                                </Typography>

                                {/* Subhead */}
                                <Typography variant="body1" sx={{
                                    fontSize: { xs: '14px', sm: '16px' }, // Responsive font size
                                    color: '#4b5563',
                                    marginBottom: '2rem',
                                    textAlign: 'center',
                                }}>
                                    Let's get those travel expenses organized and make your event planning a breeze.
                                </Typography>

                                {/* Receipt Management Features */}
                                <Box sx={{ display: 'flex', flexDirection: 'column', gap: { xs: 2, sm: 2.5 } }}> {/* Responsive gap */}

                                    {/* Link */}
                                    <Box sx={{display: 'flex', alignItems: 'flex-start', gap: 2}}>
                                        <i className="icon-link"
                                           style={{color: '#0ea5e9', fontSize: '28px'}}/>
                                        <Box>
                                            <Typography variant="subtitle1"
                                                        sx={{fontWeight: 600, color: '#1f2937'}}>
                                                Link to Your Adventures
                                            </Typography>
                                            <Typography variant="body2" color="text.secondary">
                                                Connect receipts directly to activities, meals, or
                                                lodging for a complete financial picture of your itinerary.
                                            </Typography>
                                        </Box>
                                    </Box>
                                    {/* Location */}
                                    <Box sx={{display: 'flex', alignItems: 'flex-start', gap: 2}}>
                                        <i className="icon-map-marker"
                                           style={{color: '#0ea5e9', fontSize: '28px'}}/>
                                        <Box>
                                            <Typography variant="subtitle1"
                                                        sx={{fontWeight: 600, color: '#1f2937'}}>
                                                Capture Essential Details
                                            </Typography>
                                            <Typography variant="body2" color="text.secondary">
                                                Record location, service date, and other key information to ensure
                                                every expense is fully documented.
                                            </Typography>
                                        </Box>
                                    </Box>
                                    {/* Clarity */}
                                    <Box sx={{display: 'flex', alignItems: 'flex-start', gap: 2}}>
                                        <i className="icon-head-money"
                                           style={{color: '#0ea5e9', fontSize: '28px'}}/>
                                        <Box>
                                            <Typography variant="subtitle1"
                                                        sx={{fontWeight: 600, color: '#1f2937'}}>
                                                Enhanced Accountability & Clarity
                                            </Typography>
                                            <Typography variant="body2" color="text.secondary">
                                                Maintain full accountability for every expense with clear,
                                                detailed records for peace of mind.
                                            </Typography>
                                        </Box>
                                    </Box>
                                    {/* Categorization */}
                                    <Box sx={{display: 'flex', alignItems: 'flex-start', gap: 2}}>
                                        <i className="icon-pie-chart"
                                           style={{color: '#0ea5e9', fontSize: '28px'}}/>
                                        <Box>
                                            <Typography variant="subtitle1"
                                                        sx={{fontWeight: 600, color: '#1f2937'}}>
                                                Smart Categorization & Business Tracking
                                            </Typography>
                                            <Typography variant="body2" color="text.secondary">
                                                Categorize expenses for clear insights and easily
                                                mark them as business-related for accurate reporting.
                                            </Typography>
                                        </Box>
                                    </Box>
                                    {/* Reports */}
                                    <Box sx={{display: 'flex', alignItems: 'flex-start', gap: 2}}>
                                        <i className="icon-file-check"
                                           style={{color: '#0ea5e9', fontSize: '28px'}}/>
                                        <Box>
                                            <Typography variant="subtitle1"
                                                        sx={{fontWeight: 600, color: '#1f2937'}}>
                                                Simplify Expense Reports
                                            </Typography>
                                            <Typography variant="body2" color="text.secondary">
                                                Receipts automatically accompany your reports, streamlining
                                                reimbursements and financial reviews.
                                            </Typography>
                                        </Box>
                                    </Box>
                                </Box>

                                <Box sx={{ mt: 4, textAlign: 'center' }}>
                                    <Typography variant="body2" sx={{ fontStyle: 'italic', color: '#616161', mb: 2 }}>
                                        Organized adventures are truly unforgettable ones!
                                    </Typography>
                                    <Typography
                                        variant="button"
                                        sx={{
                                            marginTop: '12px',
                                            display: 'inline-block',
                                            color: '#fff',
                                            backgroundColor: '#1976d2',
                                            padding: '8px 16px',
                                            borderRadius: '8px',
                                            cursor: 'pointer',
                                            mt: 2,
                                        }}
                                        data-id="new-entry"
                                        onClick={handleReceiptsListMenuClick}
                                    >
                                        Add Your First Receipt
                                    </Typography>
                                </Box>
                            </CardContent>
                        </Card>

                    )
                }
            </div>

            <InfoReceipts
                isOpen={isReceiptsInfoDialogOpen}
                onClose={() => setReceiptsInfoDialogOpen(false)}
            />

            <Dialog
                open={deleteConfirmOpen}
                onClose={() => setDeleteConfirmOpen(false)}
                PaperProps={{ sx: { borderRadius: '20px', p: 1, maxWidth: '400px' } }}
            >
                <DialogTitle sx={{ fontWeight: 800, color: '#151269', display: 'flex', alignItems: 'center', gap: 1 }}>
                    <i className="icon-trash" style={{ color: '#d32f2f' }} />
                    Confirm Delete
                </DialogTitle>

                <DialogContent>
                    <Typography sx={{ color: '#555', fontWeight: 500, lineHeight: 1.5 }}>
                        Are you sure you want to remove this receipt? This will permanently delete the record and the associated image from the cloud.
                    </Typography>
                </DialogContent>

                <DialogActions sx={{ p: 2, pb: 3, justifyContent: 'center', gap: 2 }}>
                    <Button
                        onClick={() => setDeleteConfirmOpen(false)}
                        sx={{ color: '#666', fontWeight: 700, textTransform: 'none' }}
                    >
                        No, Keep it
                    </Button>
                    <Button
                        variant="contained"
                        onClick={() => {
                            executeDelete();
                            setDeleteConfirmOpen(false);
                        }}
                        sx={{
                            bgcolor: '#d32f2f',
                            borderRadius: '12px',
                            fontWeight: 800,
                            px: 4,
                            textTransform: 'none',
                            boxShadow: '0 4px 12px rgba(211, 47, 47, 0.2)',
                            '&:hover': { bgcolor: '#b71c1c' }
                        }}
                    >
                        Yes, Delete
                    </Button>
                </DialogActions>
            </Dialog>

        </div>
    )
}

export default ReceiptList;